export const APP_VERSION = require('../../package.json').version;
